import { createElement, memo } from '@hfe/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import './RichTextList.scss';
function RichTextList(p) {
    return <View className="rich-text-list-container">
      {p.richTextList.map((richTextItem, index) => {
        const textColor = {
            color: richTextItem.textcolor
        };
        return <View key={index}>
            <Text x-if={!p.isSubTitle} className="rich-text-list-title-text" style={textColor}>{richTextItem.text}</Text>
            <Text x-if={p.isSubTitle} className="rich-text-list-subtitle-text" style={textColor}>{richTextItem.text}</Text>
          </View>;
    })}
    </View>;
}
export default memo(RichTextList);
